const LEAD_GEN_CONNECTOR_ID = 'bd266322-e346-11ed-b3ae-069b33d65119';

export const deleteChatHistory = () => {
  // Clear lead gen chat data
  Object.entries(localStorage)
    .filter(item => item[0].startsWith(LEAD_GEN_CONNECTOR_ID))
    .map(item => item[0])
    .forEach(key => localStorage.removeItem(key));
};
